export default [
    {
        path: '/error/blocked',
        name: 'ErrorBlocked',
        component: () => import('@/views/errors/Blocked.vue'),
        meta: { access: 'auth', title: 'routes.errors.blocked', allowIfCompanyError: true }
    },
    {
        path: '/error/deleted',
        name: 'ErrorDeleted',
        component: () => import('@/views/errors/Deleted.vue'),
        meta: { access: 'auth', title: 'routes.errors.deleted', allowIfCompanyError: true }
    },
    {
        path: '/error/internal',
        name: 'ErrorInternal',
        component: () => import('@/views/errors/Internal.vue'),
        meta: { access: 'auth', title: 'routes.errors.internal', allowIfCompanyError: true }
    },
    {
        path: '/errors/moderation',
        name: 'ErrorModeration',
        component: () => import('@/views/errors/ErrorModeration.vue'),
        meta: { title: 'routes.errors.moderation', authRequired: true },
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('@/views/account/logout.vue'),
        meta: { title: 'routes.errors.logout', access: 'auth' }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/errors/404-cover.vue'),
        meta: { access: 'auth', title: 'routes.errors.not_found' }
    }
];